module.exports = __webpack_public_path__ + "img/Weapon_187.b28f40f2.png";